module.exports = __webpack_public_path__ + "img/xw_img_01.d7ec5c53.png";